import React, { useEffect } from "react";
import {
  Box,
  InputLabel,
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { CountryList } from "../redux/Thunk/ClientModule/ClientThunk";

const MobileNumberField = ({
  id,
  name: parentName, // We'll store the parent’s "name" prop (e.g., "mobile") in parentName
  label,
  value = {},        // shape: { countryIso, phoneCode, number }
  onChange,
  error,
  isNotMandatory,
  ...rest
}) => {
  // Safely extract fields from value object
  const { countryIso = "", phoneCode = "", number = "" ,nicename=""} = value;

  // Get country list from Redux
  const { country } = useSelector((state) => state.root.ClientModule);
  const dispatch = useDispatch();

  // Load country list on mount
  useEffect(() => {
    dispatch(CountryList());
  }, [dispatch]);
  useEffect(() => {
    if (!value.countryIso && country.length > 0) {
      const defaultCountry = country.find((c) => c.iso === "US");

      if (defaultCountry) {
        const defaultValue = {
          ...value,
          countryIso: defaultCountry.iso,
          phoneCode: defaultCountry.phonecode,
          nicename: defaultCountry.nicename,
        };

        onChange({
          target: {
            name: parentName,
            value: defaultValue,
          },
        });
      }
    }
  }, [value.countryIso, country]);

  // Single combined change handler
  const handleCombinedChange = (e) => {
    const { name: fieldName, value: fieldValue } = e.target;

    // Make a copy of the current object
    const newValue = { ...value };

    // Determine which field changed (countryIso or number)
    if (fieldName === "countryIso") {
      newValue.countryIso = fieldValue;
      // Update phoneCode based on selected country
      const selectedCountry = country.find((c) => c.iso === fieldValue);
      newValue.phoneCode = selectedCountry ? selectedCountry.phonecode : "";
      newValue.nicename = selectedCountry ? selectedCountry.nicename : "";
    } else if (fieldName === "number") {
      newValue.number = fieldValue;
    }

    // Fire a synthetic event up to the parent’s handleChange
    onChange({
      target: {
        name: parentName, // e.g., "mobile"
        value: newValue,
      },
    });
  };

  return (
    <>
      {/* Label & Error Handling */}
      <InputLabel shrink htmlFor={id} error={!!error}>
            {label}
            <span className="text-error">{isNotMandatory ? "" : "*"}</span>
      </InputLabel>

      {/* TextField with Select in the startAdornment */}
      <TextField 
        className="mobile-number-field"
        id={id}
        // We override the "name" so we know whether user is typing number or changing country:
        name="number"
        value={number}
        error={!!error}
        onChange={handleCombinedChange}
        helperText={error}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" >
              <Select
              edge="start"
                // A separate "name" for the Select so we can detect it in handleCombinedChange
                name="countryIso"
                value={countryIso}
                onChange={handleCombinedChange}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) {
                    return <em>Select Country</em>;
                  }
                  const selectedItem = country.find((c) => c.iso === selected);
                  if (!selectedItem) return "";

                  return (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      {/* Flag */}
                      <img
                        src={`https://flagcdn.com/16x12/${selectedItem.iso.toLowerCase()}.png`}
                        alt={selectedItem.name}
                        style={{ width: 20, height: "auto" }}
                      />
                      {/* Phone code */}
                      <Typography variant="body2" component="span">
                        +{selectedItem.phonecode}
                      </Typography>
                    </Box>
                  );
                }}
              >
                {country.map((option) => (
                  <MenuItem key={option.iso} value={option.iso}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <img
                        src={`https://flagcdn.com/16x12/${option.iso.toLowerCase()}.png`}
                        alt={option.name}
                        style={{ width: 20, height: "auto" }}
                      />
                      <Typography variant="body2" component="span">
                        {option.nicename} (+{option.phonecode})
                      </Typography>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </InputAdornment>
          ),
        }}
        {...rest}
      />
    </>
  );
};

export default MobileNumberField;
